import React, { Component } from 'react';
import CardView from 'components/Views/CardView/CardView';
import companyInformationloader from 'assets/img/placeholders/company_information.svg';

export class CompanyInformationLoader extends Component {
  render() {
    return (
      <CardView childComponent={
        <img className="responsive-image" src={companyInformationloader} />
      } />
    )
  }
}

export default CompanyInformationLoader;
